
function GetSuggestedProducts() {
    if ($("#CurCatalogID").length > 0 && $(".AutoGetSuggested").length > 0) {
        $.ajax({
            type: "GET",
            url: getRequestRoute() + "/p/ProductDetails/GetSuggestedProducts",
            data: "ProductID=" + $("#ProductID").val() + "&CurCatalogID=" + $("#CurCatalogID").val() + "&ColorID=" + $(".Colors .ColorOptionItem.active:first a").attr("data-id"),
            cache: false,
            success: function (dt) {
                dt = dt.replace("_buyuk", "_kucuk");
                $(".AutoGetSuggested .AutoSetted").remove();

                if (dt != "") {
                    $(".AutoGetSuggested").append(dt);
                    $(".AutoGetSuggested .Productsuggest .ProductList").addClass("col-xs-24");
                }
            }
        });
    }
}

function SetLastVisitedProductsStorage() {
    var LastVisitedPrds = [];
    var lastPrdsKey = "LastVisitedPrds-" + $("#SmallCountryCode").val() + "-" + $("#SmallLangCode").val();

    if (typeof (Storage) !== "undefined") {
        if ($(".ProductHeader:first").length > 0 || $(".AutoGetLastVisited").length > 0) {
            var hours = 8; // Reset when storage is more than 24hours
            var now = new Date().getTime();
            var setupTime = localStorage.getItem('prdLastSetupTime');

            if (setupTime == null) {
                localStorage.setItem('prdLastSetupTime', now);
            } else {
                if (now - setupTime > hours * 60 * 60 * 1000) {
                    localStorage.removeItem(lastPrdsKey);
                    localStorage.setItem('prdLastSetupTime', now);
                }
            }

            var _productid = $("#ProductID:first").val();
            var _colorid = $("#ColorID:first").val();
            var _url = window.location.pathname;
            var _prdImg = $("#FirstAngle:first").val();//$("meta[property$=image]").attr("content");
            var _prdname = $(".ProductHeader:first").text();
            var _amount = $(".PriceItem:first").text();

            _prdname = _prdname.replace(/(\r\n|\n|\r)/gm, "").trim();

            LastVisitedPrds = GetLastVisitedData();

            var itemExist = false;

            for (var i = 0; i < LastVisitedPrds.length; i++) {
                if (LastVisitedPrds[i].ColorID == _colorid && LastVisitedPrds[i].ProductID == _productid) {
                    itemExist = true;
                }
            }

            if (!itemExist) {
                LastVisitedPrds.push({ Amount: _amount, ProductID: _productid, ColorID: _colorid, Url: _url, Img1: _prdImg, Img2: _prdImg, ProductName: _prdname });

                if (LastVisitedPrds.length > 6) {
                    LastVisitedPrds.shift();
                }

                localStorage.setItem(lastPrdsKey, JSON.stringify(LastVisitedPrds));
            }
        }
    }
}

function SlickSlider(SuggestedSlick) {
    if (SuggestedSlick == "suggested") {
        if ($(".SuggestedProductsContainer.LastVisited .SuggestedProducts .ProductList .Prd").length > 3) {
            $(".SuggestedProductsContainer.LastVisited .SuggestedProducts .ProductList").slick({
                nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-right'></i></div>",
                prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-left'></i></div>",
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                lazyLoad: 'ondemand',
                arrows: true,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true
                        }
                    }
                ]
            });
        }
        else {
            $(".UseLazyLoadSuggested").Lazy();
        }
    }
    else if (SuggestedSlick == "main") {
        UseSliderObject = "";

        if ($("#NewPd").hasClass("Combines")) {
            UseSliderObject = $('.ProductDetailImages ul');
        }
        else {
            UseSliderObject = $('.ProductDetailsMainImage ul');
        }

        $().fancybox({
            selector: '.js-fancy-image-item:not(.slick-cloned)',
            slideShow: {
                autoStart: false,
                speed: 2000
            },
            buttons: [
                "zoom",
                "slideShow",
                "close"
            ],
            loop: false,
            thumbs: {
                autoStart: false
            },
            backFocus: false
        });

        // Main Slider
        UseSliderObject.slick({
            nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-right'></i></div>",
            prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-left'></i></div>",
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            lazyLoad: 'ondemand',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                }
            ]
        });

        if (!isMobileResolution()) {
            $('.SmallProductImages ul').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                asNavFor: UseSliderObject,
                focusOnSelect: true,
                vertical: true
            });
        }

        $(document).on("click", ".ProductDetailsMainImage  .js-fancy-image-item:not(.slick-cloned)", function () {
            $(".ProductDetailsMainImage  .js-fancy-image-item").each(function () {
                var thisImage = $(this).find(".main-image");
                var thisAttr = thisImage.attr("data-lazy");

                if (thisAttr != "" && thisAttr != undefined) {
                    thisImage.attr("src", thisImage.attr("data-lazy"));
                    thisImage.removeAttr("data-lazy");

                    //$(this).find(".small-img-for-fancy").remove();
                }
            });
        });

    }
    else if (SuggestedSlick == "combine") {
        if ($(".CombineProduct .SuggestedProducts .ProductList .Prd").length > 2) {
            console.log("combine");
            $(".CombineProduct .SuggestedProducts .ProductList").slick({
                nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-right'></i></div>",
                prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-left'></i></div>",
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                //lazyLoad: 'ondemand',
                arrows: true,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true
                        }
                    }
                ]
            });
        }
        else if ($(".SuggestedProductsContainer.CombineProduct .SuggestedProducts .ProductList .Prd").length > 0) {
            $(".SuggestedProductsContainer.CombineProduct .SuggestedProducts .ProductList .Prd").each(function () {
                $(this).find(".PImage").attr("src", $(this).find(".PImage").attr("data-lazy"));
            });
        }
    }

    if (SuggestedSlick == "search") {
        if ($(".searchArea .SuggestedProductsContainer .AutoGetLastVisited .SuggestedProducts .ProductList .Prd").length > 3) {
            $(".searchArea .SuggestedProductsContainer .AutoGetLastVisited .SuggestedProducts .ProductList").slick({
                nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-right'></i></div>",
                prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-left'></i></div>",
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 1,
                //lazyLoad: 'ondemand',
                arrows: true,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true
                        }
                    }
                ]
            });
        }
        else {
            $(".searchArea .SuggestedProductsContainer .AutoGetLastVisited .SuggestedProducts .ProductList .UseLazyLoadSuggested").each(function () {
                var img = $(this).attr("data-lazy");
                if (img != null && img != "" && img != undefined) {
                    $(this).attr("src", img);
                }
            });
        }
    }
}

$(document).ready(function () {
    IsfollowForProductDetails();
    GetSuggestedProducts();
    SlickSlider("main");
    SlickSlider("combine");
    ProductComment();

    //if ($("body").hasClass("productdetails") && $("#CName").val() == "ProductDetails" && $("#AName").val() == "Index") {
    //    SetLastVisitedProductsStorage();

    //    var LastVisitedPrds = GetLastVisitedData();

    //    if (LastVisitedPrds != undefined && LastVisitedPrds.length > 0) {
    //        GetLastVisitedPrdView(LastVisitedPrds, function (dt) {
    //            if (dt != "") {
    //                $(".SuggestedProductsContainer.LastVisited .AutoGetLastVisited").append(dt);

    //                if ($(".productdetails .SuggestedProductsContainer .AutoGetLastVisited .SuggestedProducts").length > 0) {
    //                    SlickSlider("suggested");

    //                    //if (!isMobileResolution()) {
    //                    //    $(".UseLazyLoadSuggested").Lazy();
    //                    //}
    //                }
    //            }
    //        });
    //    }
    //}

    // StoreStock modal open
    $(".ProductDetail  .StoreStockArea .StoreStocksLink").live("click", function () {
        $("#StoreStocksTable").modal();
        if ($("#StoreStocksTable .ProductContent .Sizes span .active").length > 0) {
            GetStoreStocksTrigger();
        }
    });
    $("#StoreStocksTable modal-header .close").live("click", function () {
        $("#StoreStocksTable").hide();
    });

    // To Operations
    $('.PdInstallmentOptions, .PrInstallmentOptions').live("click", function (e) {
        var Amount = $(".PriceItem:first").html();
        GetProductInstalments(Amount);
    });

    //SEPETE EKLE
    $(".AddToBasket.ProductDetails #Basket").live("click", function (e) {
        var SizeID = $("#SizeID").val();
        var ColorID = $("#ColorID").val();
        var ProductID = $("#ProductID").val();
        var Amount = 1;
        var LangID = $("#LangID").val();
        var BedenSec = $('#BedenSec').val();
        var RenkSec = $('#RenkSec').val();
        var UrunYok = $('#UrunYok').val();

        $basketButton = $(this);
        $basketButton.prop("disabled", true);

        if (SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeID != "" && ColorID != "" && ProductID != "") {
            var NormalText = $basketButton.html();
            var AddingText = $basketButton.attr("data-adding");
            $basketButton.html(AddingText);

            var data = 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + Amount + "&langID=" + LangID;

            //GenerateLocalLoading($(".ProductDetail"), "show");
            $(".backdrop").addClass("active");

            AddToCard(data, function (dt) {
                $basketButton.html(NormalText);

                if (dt.Sonuc == true) {
                    GetSepetIcerik(function (dt) {
                        $("#UserAndBasket").html(dt);

                        //if (!isMobileResolution() {
                        //    toggleBasket();
                        //}

                        toggleBasket();

                        // 5 sn. sonra kapansın                                
                        setTimeout(function () {
                            if ($("body").hasClass("BasketDropped")) {
                                toggleBasket();
                            }
                        }, 5000);

                        var basketCount = document.querySelector('.SepetButton');
                        if (basketCount) {
                            basketCount.classList.add('wiggle-animation');
                        }
                        setTimeout(function () {
                            basketCount.classList.remove('wiggle-animation');
                        }, 5000);

                    });
                }
                else {
                    SwalGenerate("error", dt.IslemSonucAciklama, getStandartMessages("Hata"), getStandartMessages("Kapat"));
                }

                //GenerateLocalLoading($(".ProductDetail"), "hide");
                $(".backdrop").removeClass("active");
                $basketButton.prop("disabled", false);
            });
        }
        else {
            if (SizeID == undefined || SizeID == "") {
                $(".backdrop").addClass("active");
                $(".SizeOptions").addClass("PleaseSelect");
                $(".AddToBasket").addClass("PleaseSelect");

                $(".ProductOptions").addClass("PleaseSelectFixedArea");

                //setTimeout(function () {
                //    $(".ProductOptions").addClass("PleaseSelectFixedArea");
                //}, 500);

                //if ($(window).width() > 767) {
                //    $(".ProductOptions").css("position", "unset");
                //    $("body").css("overflow", "hidden");
                //}

                var OptionAreaScrollTop = 0;
                if (isMobileResolution()) {
                    OptionAreaScrollTop = $(".SizeOptions").offset().top - 250;
                }

                $('html, body').animate({
                    scrollTop: OptionAreaScrollTop
                }, 500);

                if ($(".AutoTextRep").length > 0) {
                    $(".AddToBasket button").attr("data-first", $(".AddToBasket button").html());
                    $(".AddToBasket button").text($('#BedenSec').val());

                    $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").html());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }
            }

            if (ColorID == undefined || ColorID == "") {
                alert(RenkSec);

                $(".AddToBasket button").attr("data-first", $(".AddToBasket button").html());
                $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").html());

                if ($(".AutoTextRep").length > 0) {
                    $(".AddToBasket button").text($('#BedenSec').val());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }
            }

            if (ProductID == undefined || ProductID == "") alert(UrunYok);


        }

        e.preventDefault();
        return false;
    });

    //Ürün Beden Seçimi
    $('.SizeOptions a:not(.NotifyWhen)').live("click", function () {
        $(this).parents(".Sizes").find("#SizeID").val($(this).attr("data-id"));

        $(this).parents(".SizeOptions").find("a").removeClass("active");
        $(this).parents(".SizeOptions").find("span").removeClass("active");
        $(this).addClass("active");
        $(this).parent().addClass("active");

        if ($(".NewPD").length > 0) {
            $(".SizeOptions, .SizeAndAmount span.ChooseTitle").addClass("passed");
            $(".Colors span.ChooseTitle").removeClass("current");
            $(".Colors span.ChooseTitle").addClass("passed");

            $(".Sizes span.ChooseTitle").removeClass("current");
            $(".Sizes span.ChooseTitle").addClass("passed");

            $(".SizeAndAmount  > span.ChooseTitle").removeClass("current");
            $(".SizeAndAmount  > span.ChooseTitle").addClass("passed");

            $(".AmountOptions  span.ChooseTitle").removeClass("passed");
            $(".AmountOptions  span.ChooseTitle").addClass("current");

            var TrigAddBasket = false;

            if ($(".SizeOptions.PleaseSelect").length == 1) {
                TrigAddBasket = true;
            }

            $(".AddToBasket button").removeClass("NotSelected");

            if ($(".AutoTextRep").length > 0 && $(".AddToBasket button").attr("data-first") != undefined && $(".AddToBasket button").attr("data-first").length > 0 && $(".EsPD").length <= 0) {
                $(".AddToBasket button").html($(".AddToBasket button").attr("data-first"));
            }

            $(".SizeOptions").removeClass("PleaseSelect");
            $(".AddToBasket").removeClass("PleaseSelect");
            $(".ProductOptions").removeClass("PleaseSelectFixedArea");
            $(".AddToBasket.ProductDetails #Basket").prop("disabled", false);

            $(".backdrop").removeClass("active");

            if (TrigAddBasket) {
                $(".AddToBasket #Basket").click();
            }
        }
        // Stok sorgulama Modal'ı açıksa
        if ($("#StoreStocksTable").hasClass("show")) {
            GetStoreStocksTrigger();
        }
    });

    // Renk Değişimi
    $("#changeColor").live("click", function (e) {
        var LangID = $("#LangID").val();
        var ProductID = $(this).attr("data-productID");
        var ColorID = $(this).attr("data-id");
        button = $(this);

        ChangeProductColor(ProductID, ColorID, LangID, function (data, status) {
            if (status == true && data != null && data != undefined && data != "") {

                // #region ProductImages
                $(".ProductDetailsMainImage > ul").slick('unslick');
                if ($(window).width() > 991) {
                    $(".SmallProductImages > ul").slick('unslick');
                }

                // #region SmallProductImages
                if ($(window).width() > 991) {
                    $(".SmallProductImages > ul li").remove();
                }
                $(".ProductDetailsMainImage > ul li").remove();

                if (data.ImagePath != null && data.ImagePath != undefined && data.ImagePath != "") {
                    var Images = data.ImagePath.split(';');
                    var firstIteration = true;
                    $.each(Images, function (k, v) {
                        $(".ProductDetailsMainImage > ul").append('<li class="ImgArea js-fancy-image-item" href="' + v.replace("_enbuyuk", "_buyuk") + '"><img src="' + v.replace("_enbuyuk", "_buyuk") + '"  /></li>');
                        if ($(window).width() > 991) {
                            $(".SmallProductImages > ul").append('<li><img src="' + v.replace("_buyuk", "_kucuk") + '"  /></li>');
                        }
                        if (firstIteration) {
                            $("#StoreStocksTable .modal-body .ProductContent .PrImg").attr("src", v.replace("_enbuyuk", "_buyuk"));
                            firstIteration = false;
                        }
                    });
                }

                //if (isMobileResolution())
                SlickSlider("main");
                // #endregion

                // #region ProductSizes
                $(".SizeOptions").html("");

                if ($("#SelectSizePopup").length > 0) {
                    $("#SelectSizePopup span").html("");
                }

                $(".SizeOptions").removeClass("passed");
                $("#SizeID").val("");

                if (data.Sizes != null && data.Sizes != undefined && data.Sizes != "") {
                    var size = JSON.parse(data.Sizes);
                    var newSizeCount = 0;

                    $.each(size, function (k, v) {
                        var stil = "";

                        if (v.InStock == "false" || v.PStatus != "1") {
                            stil = "OutOfQuantity";

                            if ($(".NewPD").length > 0) {
                                $(".SizeOptions").append('<span class="outer">' +
                                    ' <input type="hidden" name="SizeIDs" id="SizeIDs" value="' + v.ID + '" >' +
                                    ' <span class="PdHint"> <span class="PdHint-content">Bu Ürünün ' + v.Name + ' Bedeni Stoklarla Kalmamıştır.<br />' +
                                    '<a href="javascript:;" class="NotifyWhen">Ürün stoğa geldiğinde haber ver!</a>' +
                                    ' </span><i class="reactangle"></i></span>'
                                    + '<span class="inner">' + v.Name + '</span></span>');
                            } else {
                                $(".SizeOptions").append('<span class="outer"><span class="inner">' + v.Name + '</span></span>');
                            }
                        }
                        else {
                            $(".SizeOptions").append('<span><a data-id="' + v.ID + '" data-stock="' + v.InStock + '" data-name="' + v.Name + '" href="javascript:void(0)" class="' + stil + " " + v.Name + '">' + v.Name + '</a></span>');

                            newSizeCount++;
                        }
                    });

                    if (newSizeCount > 0) {

                        var width = window.innerWidth;

                        var prcHtml = "";
                        if (width <= 991 && $('#productPrc').text() != '' && $('#productPrc').text() != undefined) {

                            if ($('#productOldPrc').text() != '' && $('#productOldPrc').text() != undefined) {
                                var originalElement = document.getElementById('productOldPrc');

                                var copiedElement = originalElement.cloneNode(true);

                                prcHtml += copiedElement.outerHTML;
                            }

                            var productPrc = document.getElementById('productPrc');

                            var productPrcElement = productPrc.cloneNode(true);

                            prcHtml += productPrcElement.outerHTML;



                        }

                        $(".AddToBasket").html(prcHtml+"<button type='button' name='Basket' data-adding='" + getStandartMessages("LutfenBekleyin") + "' id='Basket' class='CartButtonColor NotSelected btn-theme-black'><svg class='shopping-chart-icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 576 512'><path d='M0 24C0 10.7 10.7 0 24 0L69.5 0c22 0 41.5 12.8 50.6 32l411 0c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3l-288.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5L488 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z' /></svg>" + $(".AddToBasketHidden").val() + "</button>");
                    }
                    else {
                        $(".AddToBasket").html("<span class='NotAvailableProduct'>" + $(".TukendiHidden").val() + "</span>");
                    }
                }
                // #endregion

                $(".ProductHeader").html(data.ProductName);
                $(".ProductDetail .Colors .ColorThumb span").html(data.ColorName);
                // Ürün stok sorgulama modal'ı
                $("#StoreStocksTable .Colors .ColorThumb span").html(data.ColorName);

                document.title = data.ProductName + " | Perspective";

                $(".Prices .PrdouctCode span").html(data.ProductCode);

                //AmpountOld
                if (data.AmountOld > 0 && data.AmountOld > data.Amount) {
                    $(".PriceContainer .PriceOld").html(data.CurrencySymbol + " " + data.AmountOld.toFixed(2));
                }
                else {
                    $(".PriceContainer .PriceOld").html("");
                }

                $(".PriceContainer .Price ").html(data.CurrencySymbol + " " + data.Amount.toFixed(2));

                $(".Colors .ColorOption .active").removeClass("active");
                $(".AddToFavorite").attr("data-id", ProductID);
                button.parent().addClass("active");

                $("#PID").val(ProductID);
                $("#ProductID").val(ProductID);
                $("#ColorID").val(ColorID);

                $("#SizeTable #manikin-size table tbody").html("");

                if (data.MankenBoy != null && data.MankenBoy != "")
                    $("#SizeTable #manikin-size table tbody").append("<tr><td>Boy</td><td>" + data.MankenBoy + " cm</td></tr>");

                if (data.MankenBel != null && data.MankenBel != "")
                    $("#SizeTable #manikin-size table tbody").append("<tr><td>Bel</td><td>" + data.MankenBel + " cm</td></tr>");

                if (data.MankenBasen != null && data.MankenBasen != "")
                    $("#SizeTable #manikin-size table tbody").append("<tr><td>Basen</td><td>" + data.MankenBasen + " cm</td></tr>");

                if (data.MankenGogus != null && data.MankenGogus != "")
                    $("#SizeTable #manikin-size table tbody").append("<tr><td>Gogus</td><td>" + data.MankenGogus + " cm</td></tr>");

                if (data.MankenBeden != null && data.MankenBeden != "")
                    $("#SizeTable #manikin-size table tbody").append("<tr><td>Beden</td><td>" + data.MankenBeden + " cm</td></tr>");
            }
            else {

                SwalGenerate("error", getStandartMessages("SatStokYok"), getStandartMessages("IslemBasarisiz"), getStandartMessages("Kapat"));
            }
        });
        // Stok sorgulama Modal'ı açıksa
        if ($("#StoreStocksTable").hasClass("show")) {
            $(".AccordionContainer").html("");
            GetStoreStocksTrigger();
        }
    });

    // Favorilere Ekleme
    $(".passiveFavorite").live("click", function () {
        var ColorID = $("#ColorID").val();
        var ProductID = $("#ProductID").val();
        button = $(this);

        OverlayElement = $(".ProductDetail");
        if ($(window).width() < 992) {
            OverlayElement = $(".BasktButtons");
        }

        GenerateLocalLoading(OverlayElement, "show");

        if (ColorID != undefined && ProductID != undefined) {
            AddToFavorite(ColorID, ProductID, function (result, msg) {
                if (result == true) {
                    button.addClass("activeFavorite");
                    button.removeClass("passiveFavorite");
                    button.find(".sorsfont").removeClass("sorsfont-favorite").addClass("sorsfont-favorite-o");
                    SwalGenerate("success", "", getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));

                    setTimeout(function () {
                        if ($(".swal2-container .swal2-actions .swal2-confirm").length > 0) {
                            $(".swal2-container .swal2-actions .swal2-confirm").trigger("click");
                        }
                    }, 5000);
                }
                else {
                    var loginLink = getRequestRoute() + "/p/User/Login";

                    SwalGenerate("warning", msg, getStandartMessages("IslemBasarisiz"), "<a href='" + loginLink + "'>" + getStandartMessages("GirisYap") + "</a>");
                }

                GenerateLocalLoading(OverlayElement, "hide");
            });
        }
    });

    function BasketAddMessage() {
        Swal.fire({
            html: "Ürün(ler) sepetinize eklendi.",
            icon: "success",
            showCloseButton: true,
            confirmButtonText: "<a href='/tr/p/CheckOut/sepet?rf=sepet' style='color:#fff;font-weight:600;'>Siparişi Tamamla</a>",
            confirmButtonColor: "#a5dc86",
            showCancelButton: true,
            cancelButtonText: '<span style="color:#595959;font-weight:600">Alışverişe Devam Et</span>',
            cancelButtonColor: "#eaeaea"
        });
    }

    // Favorilerden Çıkarma
    $(".activeFavorite").live("click", function () {
        var ProductID = $("#ProductID").val();
        button = $(this);

        OverlayElement = $(".ProductDetail");
        if ($(window).width() < 992) {
            OverlayElement = $(".BasktButtons");
        }

        GenerateLocalLoading(OverlayElement, "show");

        if (ProductID != undefined) {
            removeFavorite(ProductID, function (result) {
                if (result == true) {
                    button.addClass("passiveFavorite");
                    button.removeClass("activeFavorite");
                    button.find(".sorsfont").removeClass("sorsfont-favorite-o").addClass("sorsfont-favorite");
                    SwalGenerate("success", "", getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));

                    setTimeout(function () {
                        if ($(".swal2-container .swal2-actions .swal2-confirm").length > 0) {
                            $(".swal2-container .swal2-actions .swal2-confirm").trigger("click");
                        }
                    }, 5000);
                }
                else {
                    SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                }

                GenerateLocalLoading(OverlayElement, "hide");
            });
        }
    });

    // Stoğa Gelince Haber Ver Modal
    $("a.NotifyWhen").live("click", function myfunction() {
        var ProductID = $("#ProductID:first").val();
        var ColorID = $("#ColorID").val();
        var SizeID = $(this).parent().parent().parent().find("input[name=SizeIDs]").val();

        if (ProductID != "" && ProductID != null && ProductID != undefined && typeof ProductID !== 'undefined' && ColorID != null && ColorID != "" && ColorID != undefined && SizeID != null && SizeID != "" && SizeID != undefined) {
            var params = "ProductID=" + ProductID + "&ColorID=" + ColorID + "&SizeID=" + SizeID;
            GetListForRemind(params);
        }
    });

    // Stoğa Gelince Haber Action
    $("#NotifyModal #RemindMeLater.active").live("click", function myfunction() {
        var StockIDs = "?x=";
        var curVal = 0;

        $(".NotiyfyRow .OutOfStockRemind").each(function (index) {
            StockIDs += "&[" + curVal + "].StockID=" + $(this).attr("data-StockID");
            StockIDs += "&[" + curVal + "].SizeID=" + $(this).attr("data-sizeID");
            StockIDs += "&[" + curVal + "].ProductID=" + $(this).attr("data-ProductID");
            StockIDs += "&[" + curVal + "].ProductCode=" + $(this).attr("data-ProductCode");
            StockIDs += "&[" + curVal + "].ColorID=" + $(this).attr("data-colorid");

            curVal++;
        });

        var name = $('input[name="NameModal"]').val();
        var username = $('input[name="UserNameModal"]').val();

        var gsm = $('input[name="GsmModal"]').val();
        var gsmLen = 0;

        if (gsm != "" && gsm != null) {
            gsmLen = gsm.length;
        }

        //var kvkk = $('input[name="KVKKModal"]').prop("checked");
        var kvkk = true;

        if (kvkk == true && name != null && username != null && name != "" && username != "" && gsm != "") {
            if (gsmLen < 10) {
                SwalGenerate("error", getStandartMessages("GecerliTelefonNumarasi"), getStandartMessages("Hata"), getStandartMessages("TekrarDene"));
            }
            else {
                var param = StockIDs + "&Name=" + name + "&UserName=" + username + "&Gsm=" + gsm + "&kvkk=" + kvkk;
                RemindMeWhenAvailable(param);
            }
        }
        else {
            SwalGenerate("warning", getStandartMessages("LutfenTumAlanlariDoldurun"), getStandartMessages("Hata"), getStandartMessages("TekrarDene"));
        }

        return false;
    });
    // To Operations

    // Slider Setting
    $('.ProductDetailImages ul').on('afterChange', function (event, slick, currentSlide, nextSlide) {
        $(".SmallProductImages ul li").each(function () {
            if ($(this).data("slick-index") == currentSlide) {
                $("img", this).addClass("Selected");
            }
            else {
                $("img", this).removeClass("Selected");
            }
        });
    });

    ////Image Zoom
    //$().fancybox({
    //    selector: '.fancybox'
    //});

    // Open SizeTable Modal
    $(".SizeTableLink").live("click", function () {
        $("#SizeTable").modal();
    });

    // Backdrop Setting
    $("body.productdetails .backdrop").on("click", function (e) {
        $(".backdrop").removeClass("active");

        $(".SizeOptions.open").removeClass("PleaseSelect");
        $(".SizeOptions, .CombineSizeOptions").removeClass("PleaseSelect");
        $(".AddToBasket.PleaseSelect").removeClass("PleaseSelect");

        $(".ProductOptions").removeClass("PleaseSelectFixedArea");
        $(".AddToBasket.ProductDetails #Basket").prop("disabled", false);

        if ($(".AutoTextRep").length > 0) {
            $(".AutoTextRep button").html($(".AutoTextRep button").attr("data-first"));
        }

        if (!isMobileResolution()) {
            $("body").css("overflow", "unset");
        }

        $("body").removeClass("no-scroll");
    });

    $(document).on("click", ".SizeOptions > span > a", function () {
        var quantity = $(this).attr("data-quantity");

        if (quantity && quantity == 1) {
            $("#SelectSizePopup span").html("Son 1 adet kaldı");
        }
        else if (quantity && quantity == 2) {
            $("#SelectSizePopup span").html("Son 2 adet kaldı");
        }
        else if (quantity && quantity == 3) {
            $("#SelectSizePopup span").html("Son 3 adet kaldı");
        }
        else if (quantity && quantity == 4) {
            $("#SelectSizePopup span").html("Son 4 adet kaldı");
        }
        else if (quantity && quantity == 5) {
            $("#SelectSizePopup span").html("Son 5 adet kaldı");
        }
        else {
            $("#SelectSizePopup  span").html("");
        }
    });

    if ($(".SizeOptions .ONE.SIZE").length > 0) {
        $(".SizeOptions .ONE.SIZE").trigger("click");
    }
});

function ProductComment() {
    RatingStarts();

    $(document).on("click", ".ProductDetail .ProductComments #AddComment, .ProductDetail .ProductComments .FirstComment", function () {
        var ProductID = $("#PID").val();

        $.ajax({
            type: "GET",
            url: getRequestRoute() + "/p/ProductDetails/CommentLoginControl",
            data: "ProductID=" + ProductID,
            cache: false,
            success: function (data) {

                data = JSON.parse(data);

                if (data.CanComment == false) {
                    SwalGenerate("error", "Resmi gazetede çıkan yeni yönetmeliğe göre ürün yorumlarını sadece ürünü satın alan müşteriler yapabilir. Anlayışınız için teşekkür ederiz.", getStandartMessages("Hata"), getStandartMessages("Kapat"));
                }
                else if (data.IsLogin == false) {
                    var loginLink = getRequestRoute() + "/p/User/Login";
                    SwalGenerate("warning", "Yorum yapabilmek için giriş yapmalısınız.", getStandartMessages("IslemBasarisiz"), "<a href='" + loginLink + "'>" + getStandartMessages("GirisYap") + "</a>");
                }
                else {
                    if (data.HasComment == false) {
                        RateStarsOperation("destroy");
                        RateStarsOperation("init");

                        $("#CommentModal .modal-body .CommentInputArea textarea").val("");

                        if (!$("#CommentModal .modal-footer a").hasClass("disabled")) {
                            $("#CommentModal .modal-footer a").addClass("disabled");
                        }
                    }
                    else {

                        $Stars = $("#CommentModal .RateStars");
                        $Stars.rateYo("rating", data.Rating);
                        $("#CommentModal .modal-body .CommentInputArea textarea").val(data.Comment);

                        if (!data.ShowName) {
                            $("#CommentModal .modal-body .CheckItem.ShowName .AllowCheck").removeClass("checked");
                        }

                        if ($("#CommentModal .modal-footer a").hasClass("disabled")) {
                            $("#CommentModal .modal-footer a").removeClass("disabled");
                        }
                    }

                    $("#CommentModal").modal();
                }
            },
            error: function (dt) {
                //window.location.href = "/tr/p/User/Login";
            }
        });
    });

    $(document).on("click", ".js-load-more-comment", function () {
        var ProductID = $(this).attr("data-productid");
        var LangID = $("#LangID").val();
        var PageNo = $(this).attr("data-pageNo");
        var Filter = "";

        var RequestData = "ProductID=" + ProductID + "&LangID=" + LangID + "&PageNo=" + PageNo;

        if ($(".js-filter-item-element.active").length > 0) {
            Filter = $(".js-filter-item-element.active").first().attr("data-rate");

            RequestData += "&filter=" + Filter;
        }

        GetProductComment(RequestData, function (status, data) {
            if (status) {
                $(".js-load-more-comment").parent(".LoadMore").remove();
                $(".CommentArea").append(data);
            }
        });
    });

    $(document).on("click", "#CommentModal .modal-footer a", function () {
        $button = $(this);

        if (!$(this).hasClass("disabled")) {

            var getRating = RateStarsOperation("get");
            var errMsg = "";

            if (getRating < 1 || getRating > 5) {
                errMsg = $("#CommentModal .RateWarning").text();
            }

            if (errMsg != "") {
                SwalGenerate("error", errMsg, getStandartMessages("Hata"), getStandartMessages("Kapat"));
            }
            else {
                var ProductCode = "";
                var LangID = $("#LangID").val();
                var ProductID = $("#PID").val();
                var ColorID = $("#ColorID").val();
                var Comment = $("#CommentModal .modal-body .CommentInputArea textarea").val();
                var AllowShowName = $("input[type='checkbox'][name='ShowName']").prop("checked");

                var param = "ProductID=" + ProductID + "&ColorID=" + ColorID + "&ProductCode=" + ProductCode + "&Rate=" + getRating + "&Comment=" + Comment + "&ShowName=" + AllowShowName + "&LangID=" + LangID;

                var CurrentText = $button.text();
                $button.text($button.attr("data-adding") + "...");

                $.ajax({
                    Type: "GET",
                    url: getRequestRoute() + "/p/ProductDetails/AddComment",
                    data: param,
                    cache: false,
                    success: function (data) {

                        data = JSON.parse(data);

                        if (data.Sonuc == false) {
                            SwalGenerate("error", data.IslemSonucAciklama, getStandartMessages("Hata"), getStandartMessages("Kapat"));
                        }
                        else {
                            $("#CommentModal").modal("hide");

                            $ConfirmModal = $("#ConfirmCommentModal");
                            $ConfirmModal.modal("show");
                            $ConfirmModal.find(".ResultText").text(data.IslemSonucAciklama);
                        }

                        $button.text(CurrentText);

                        $Commentbutton = $(".ProductComments #AddComment");
                        $Commentbutton.text($Commentbutton.attr("data-UpdateCommentText"));

                    },
                    error: function (data) {
                        SwalGenerate("error", "Sistemde bir hata oluştu. Lütfen bizimle iletişime geçiniz.", getStandartMessages("Hata"), getStandartMessages("Kapat"));
                        $button.text(CurrentText);
                    }
                });
            }
        }
    });

    $(document).on("click", "#CommentModal .modal-body .CommentLabel  .CommentCriterias", function () {
        $("#CommentCriteriasModal").modal("show");
    });

    $(document).on("click", "#ConfirmCommentModal .modal-footer a", function () {
        $("#ConfirmCommentModal").modal("hide");
    });

    $("#ConfirmCommentModal").on('hide.bs.modal', function () {
        location.reload();
    });

    /////////////////////////////////////////////////////////////////

    $(document).on("click", ".btn-comment", function () {
        UserCommentRatingStarts();

        $("#CommentModal .modal-body .CommentInputArea textarea").val("");

        var ProductID = $(this).attr("data-id");
        var ColorID = $(this).attr("data-color-id");
        var UserRate = $(this).attr("data-user-rating");

        $.ajax({
            type: "GET",
            url: getRequestRoute() + "/p/User/CommentModal",
            data: "ProductID=" + ProductID + "&ColorID=" + ColorID + "&UserRate=" + UserRate,
            cache: false,
            success: function (data) {
                data = JSON.parse(data);

                RateStarsOperation("destroy");
                RateStarsOperation("init");

                if (data.UserRate !== null) {
                    $Stars = $("#CommentModal .RateStars");
                    $Stars.rateYo("rating", data.UserRate);
                    //console.log(data.UserRate)
                }

                $("#comment-image").attr('src', data.ImagePath);
                $(".CommentModalProductContent .CmpContent .PdName").html(data.ProductName);
                $("#PID").val(data.ProductID);
                $(".comment-modal-color-id").val(data.ColorID);
                $(".CommentInputArea textarea").val(data.Comment);

                $("#CommentModal").modal();

                $('#Private-Close-Modal').click(function () {
                    $('#CommentModal').modal('hide');
                });

            },
            error: function (dt) {
                //window.location.href = "/tr/p/User/Login";
            }
        });

    });

    // SizeMe SepeteEkleme

    //$(document).on("click", ".sizemeBodySizeInformationProposal .sizeandmeButton", function () {

    //    var sizeAndMe = "sizeandme";

    //    var sizeAndMeUserKey = localStorage.getItem("SizeAndMeUserKey");

    //    $.ajax({
    //        url: getRequestRoute() + "/p/User/SetUtmParam",
    //        data: "utm_source=" + sizeAndMe + "&utm_campaign=" + sizeAndMe + "&utm_medium=" + sizeAndMeUserKey,
    //        type: "POST",
    //        cache: false
    //    });
    //});
}

function GetProductComment(RequestData, callback) {
    $.ajax({
        type: "GET",
        url: getRequestRoute() + "/p/ProductDetails/GetProductComment",
        data: RequestData,
        cache: false,
        beforeSend: function () {
            //GenerateLocalLoading($(".js-load-more-comment"), "show");
            GenerateLocalLoading($(".ProductComments .AppArea"), "show");
        },
        complete: function () {
            //GenerateLocalLoading($(".js-load-more-comment"), "hide");
            GenerateLocalLoading($(".ProductComments .AppArea"), "hide");
        },
        success: function (data) {
            callback(true, data);
        },
        error: function (dt) {
            callback(false, "");
            SwalGenerate("error", "Yorumlar yüklenirken bir hata oluştu.", getStandartMessages("Hata"), getStandartMessages("Kapat"));
        }
    });
}

function RatingStarts() {
    $Stars = $("#CommentModal .RateStars");

    RateStarsOperation("init");

    // Rate Stars Change Method
    $Stars.rateYo()
        .on("rateyo.set", function (e, data) {
            $("#CommentModal .RateWarning").hide();
            $("#CommentModal .modal-footer a").removeClass("disabled");
        });

    $("#CommentModal .CommentModalCheckList .CheckItem").on("click", function () {
        $(this).children(".AllowCheck").toggleClass("checked");
    });
}

function RateStarsOperation(operation) {
    $Stars = $("#CommentModal .RateStars");

    if (operation == "init") {
        $Stars.rateYo({
            rating: 0,
            fullStar: true
        });
    }
    else if (operation == "destroy") {
        $Stars.rateYo("destroy");
    }
    else if (operation == "get") {
        return $Stars.rateYo("rating");
    }
}